import RoomSelectView from "./RoomSelectView";
import C_PointerEvt from "../core/const/C_PointerEvt";


class RoomSelectViewLandscape extends RoomSelectView
{
    constructor()
    {
        super();
    }

    addRooms()
    {
        let textSize = this.layout.relHeight(6);
        let shipSizes = [120, 120, 140];
        let betRanges = ["1-9", "10-90", "100-1000"];
        // this.textColor = [0x00baff, 0x3fccc2, 0x00c120];
        // this.textOverColor = [0xffd800, 0xff9a16, 0xff7700];

        // grey image colors
        // let roomTint = [0xff4200, 0xdeff00, 0x00d2ff];
        // this.roomTint = [0x00d000, 0xffff00, 0xff0000]; // green / yellow / red
        // this.roomTint = [0xffff00, 0x00deff, 0xb955ff]; // yellow / blue / purple
        // this.roomTint = [0x00deff, 0x00d000, 0xffff00]; // blue / green / yellow

        // COMBINE COLORS: blue: 0x00deff/0x82fffa, purple: 0xb955ff/0xcf8cff, yellow: 0xffff00/0xffff91,
        // blue: 0x00baff/0x60d3ff
        this.roomTint = [0x00deff, 0xb955ff, 0xffff00]; // blue / purple / yellow
        this.roomTintOver = [0x82fffa, 0xcf8cff, 0xffff91]; // OVER: blue / purple / yellow
        this.textColor = [0x00deff, 0xb955ff, 0xffff00];
        this.textOverColor = [0x82fffa, 0xcf8cff, 0xffff91];


        let roomData = this.model.getRoomData();
        let numRooms = roomData.length;

        for (let butIdx=0; butIdx < numRooms; butIdx++)
        {
            let roomBut = new PIXI.Container();

            let roomBg = this.assets.getSprite("room_bg_gray");
            this.layout.propHeightScale(roomBg, 45);
            roomBut.addChild(roomBg);
            roomBg.tint = this.roomTint[butIdx];

            let roomBorder = this.assets.getSprite("room_bg_border_gray");
            this.layout.propHeightScale(roomBorder, 45);
            roomBut.addChild(roomBorder);
            roomBorder.tint = this.roomTint[butIdx];

            let roomTF = this.assets.getTF("Room " + (butIdx+1), textSize, null, "#00baff");
            roomTF.style.fill = this.textColor[butIdx];
            this.layout.verticalAlignTop(roomTF, 12, roomBg);
            this.layout.horizontalAlignCenter(roomTF, 0, roomBg);
            roomBut.addChild(roomTF);

            let roomBet = this.assets.getTF(betRanges[butIdx], textSize, null, "#00baff");
            roomBet.style.fill = this.textColor[butIdx];
            this.layout.verticalAlignBottom(roomBet, 10, roomBg);
            this.layout.horizontalAlignCenter(roomBet, 0, roomBg);
            roomBut.addChild(roomBet);

            this.layout.verticalAlignMiddle(roomBut);
            let xPos = (butIdx - (numRooms - 1) * .5) * 30;
            this.layout.horizontalAlignCenter(roomBut, xPos);
            this.addChild(roomBut);

            let roomShip = this.assets.getSprite("room_ship_" + (butIdx+1));
            this.layout.propWidthScale(roomShip, shipSizes[butIdx], roomBg);
            this.layout.verticalAlignMiddle(roomShip, 0, roomBg);
            this.layout.horizontalAlignCenter(roomShip, 0, roomBg);
            roomBut.addChild(roomShip);

            roomBut.interactive = true;
            roomBut.on(C_PointerEvt.DOWN, this.onRoomSelected, this);
            roomBut.on(C_PointerEvt.OVER, this.onRoomOver, this);
            roomBut.on(C_PointerEvt.OUT, this.onRoomOver, this);
            roomBut.roomType = butIdx;
        }
    }
}

export default RoomSelectViewLandscape;